import revive_payload_client_4sVQNw7RlN from "/home/prod/v3/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/prod/v3/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/prod/v3/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/home/prod/v3/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/home/prod/v3/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/prod/v3/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/prod/v3/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/prod/v3/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/prod/v3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/home/prod/v3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/home/prod/v3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_vue3_YdLad5Mpq3 from "/home/prod/v3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/prod/v3/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/prod/v3/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/home/prod/v3/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/prod/v3/.nuxt/sentry-client-config.mjs";
import i18n_Ug908EZNww from "/home/prod/v3/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_ghbUAjaD3n from "/home/prod/v3/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_Jozdw60ZsE from "/home/prod/v3/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import slideovers_X7whXyrIWR from "/home/prod/v3/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/home/prod/v3/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/home/prod/v3/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/home/prod/v3/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/home/prod/v3/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import analytics_client_mtqVw3YRXk from "/home/prod/v3/plugins/analytics.client.ts";
import meta_pixel_client_7FDlSUjgmr from "/home/prod/v3/plugins/meta-pixel.client.ts";
import moment_NWWiRYbNqj from "/home/prod/v3/plugins/moment.ts";
import cms_xkekINWenz from "/home/prod/v3/plugins/cms.js";
import filters_znakZuvLqA from "/home/prod/v3/plugins/filters.js";
import navigation_QptjALbk5P from "/home/prod/v3/plugins/navigation.ts";
import vee_validate_K3WwmJMPDb from "/home/prod/v3/plugins/vee-validate.js";
import vue_easy_lightbox_client_lWqeizDQUL from "/home/prod/v3/plugins/vue-easy-lightbox.client.ts";
import drip_client_Re3IzsU8fq from "/home/prod/v3/plugins/drip.client.ts";
import ai_bot_client_lt6Y4xv5ko from "/home/prod/v3/plugins/ai-bot.client.ts";
import api_client_FrfnO43kJt from "/home/prod/v3/plugins/api.client.js";
import og_meta_client_QBxZjgT9P7 from "/home/prod/v3/plugins/og-meta.client.ts";
import toast_client_9z8IIRO0Dx from "/home/prod/v3/plugins/toast.client.ts";
import ssg_detect_3fHkBxLtv0 from "/home/prod/v3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  i18n_Ug908EZNww,
  plugin_ghbUAjaD3n,
  plugin_Jozdw60ZsE,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  analytics_client_mtqVw3YRXk,
  meta_pixel_client_7FDlSUjgmr,
  moment_NWWiRYbNqj,
  cms_xkekINWenz,
  filters_znakZuvLqA,
  navigation_QptjALbk5P,
  vee_validate_K3WwmJMPDb,
  vue_easy_lightbox_client_lWqeizDQUL,
  drip_client_Re3IzsU8fq,
  ai_bot_client_lt6Y4xv5ko,
  api_client_FrfnO43kJt,
  og_meta_client_QBxZjgT9P7,
  toast_client_9z8IIRO0Dx,
  ssg_detect_3fHkBxLtv0
]